export default __webpack_public_path__ + "static/media/softwareMode.3f62b96a.svg";